import PropTypes from 'prop-types';

export const Props = {
  /**
   * Optional id to assign to the element
   */
  id: PropTypes.string,
  /**
   * If true, the container will never have a max-width
   */
  fluid: PropTypes.bool,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
